import ABCyaPhaser from "@abcya/abcya_phaser";
import SoundAssetKeys from "./SoundAssetKeys";

/** @type {Phaser.Sound.HTML5AudioSound} */
let gameJingle = null;

export function createJingle(scene)
{
    gameJingle = ABCyaPhaser.Audio.createSound(scene);
}

export function playGameJingle()
{
    if (gameJingle.isPlaying) return;

    ABCyaPhaser.Audio.playSound(SoundAssetKeys._jingle, gameJingle, 1, true, 0);
}

export function stopGameJingle()
{
    gameJingle.stop();
}